function initFinishSwitcher() {
	$('body').on('click', '.js-fs-link', function(e){
		let $this = $(this);
		let imageToLoad = $this.data("imageid");
		let linksToLoad = $this.data("linksid");
		let primaryImage = $this.parents('.finish-switcher').find('.js-fs-primary-image');
		let links = $this.parents('.finish-switcher').find('.js-fs-links');

		$this.parents('.finish-switcher').find('.js-fs-link').removeClass('state-selected');
		$this.addClass('state-selected');

		primaryImage.removeClass('state-visible');
		links.removeClass('state-visible');
		$this.parents('.finish-switcher').find(`#${imageToLoad}.js-fs-primary-image`).addClass('state-visible');
		$this.parents('.finish-switcher').find(`#${linksToLoad}`).addClass('state-visible');

		e.preventDefault();
	})
}

export function init() {
	initFinishSwitcher();
}
